
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine } from "@common/src/utils/common";

const guidance = namespace("guidance");

@Component({})
export default class ComMaintenanceDetail extends Vue {
  @guidance.State maintenanceItemDetailLoading;
  emptyToLine = emptyToLine;
  @Prop({ default: () => ({}), type: Object }) itemDetailData: any;
  visible = true;
  get maintenanceItemList() {
    return Object.entries(this.itemDetailData.valueMaps || {}).map(item => {
      return {
        category: item[0],
        itemList: Object.entries(item[1])
      };
    });
  }
}
